import { useEffect } from 'react';

import {
  claimOpenImport,
  releaseOpenImport,
} from 'utils/bulkImportWizardRegistry';

/**
 * Marks `importId` as being shown by an open wizard for as long as this stays
 * mounted with that id, which suppresses the app-level completion toast.
 *
 * Pass `undefined` when the wizard is closed or hasn't started an import yet.
 * Wizards whose provider unmounts on close get the release for free from the
 * cleanup; ones that stay mounted should pass `undefined` while hidden.
 */
export default function useOpenBulkImport(importId?: string | null): void {
  useEffect(() => {
    if (!importId) return undefined;

    claimOpenImport(importId);
    return () => releaseOpenImport(importId);
  }, [importId]);
}
